import './serviceConfig.js'
import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutation'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    user: {
      name: '',
      is_admin:null
    },
    userinfo:{},
    dashboard: {
      orderDatas: [],
      categoryDatas: {
        labels: [],
        datas: []
      },
      productDatas: {
        labels: [],
        datas: []
      },
      returnDatas: []
    }
  },
  getters,
  actions,
  mutations,
  strict: debug
})



// WEBPACK FOOTER //
// ./src/vuex/index.js